import {
  NonterminalKind,
  TerminalNode as SlangTerminalNode
} from '@nomicfoundation/slang/cst';
import { SlangNode } from './SlangNode.js';
import { ModifierInvocation } from './ModifierInvocation.js';
import { TerminalNode } from './TerminalNode.js';

import type * as ast from '@nomicfoundation/slang/ast';
import type { CollectedMetadata } from '../types.d.ts';

export class ConstructorAttribute extends SlangNode {
  readonly kind = NonterminalKind.ConstructorAttribute;

  variant: ModifierInvocation | TerminalNode;

  constructor(ast: ast.ConstructorAttribute, collected: CollectedMetadata) {
    super(ast, collected);

    const variant = ast.variant;
    if (variant instanceof SlangTerminalNode) {
      this.variant = new TerminalNode(variant, collected);
      return;
    }
    this.variant = new ModifierInvocation(variant, collected);

    this.updateMetadata(this.variant);
  }
}
